import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DroppLocationModel} from '../../../../../models/integrations/dropp/dropp-location.model';

@Component({
  selector: 'app-shipping-list-item',
  templateUrl: './shipping-list-item.component.html',
  styleUrls: ['./shipping-list-item.component.css']
})
export class ShippingListItemComponent implements OnInit {

  @Input() isSelected = false;
  @Input() location: DroppLocationModel;
  @Output() valueChanged = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  onClicked() {

    if (this.valueChanged) {
      this.isSelected = !this.isSelected;
      this.valueChanged.emit(this.isSelected);
    }

  }

}
